<template>
<!--edit dialog-->
<v-dialog v-model="dialog" max-width="920" persistent scrollable :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card flat tile color="secondary">
        <v-card-title class="important white--text primary" height="50">
            Organization
        </v-card-title>
        <v-avatar v-if="organization.avatar" class="elevation-4" style="position: absolute; right: 50px; top: 25px;cursor: pointer;" @click="onFilePick()">
            <img :src="organization.avatar">
        </v-avatar>
        <v-btn v-else fab class="mx-3 elevation-4 secondary" style="position: absolute; right: 50px; top: 15px;" @click="onFilePick()">
            <v-icon color="primary">photo_camera</v-icon>
        </v-btn>
        <v-card-text class="pt-4">
            <v-form ref="organization_form" v-model="valid" autocomplete="off">
                <v-layout row no-gutters align="center">
                    <v-col cols="6" md="6" class="px-2 py-1">
                        <v-card class="elevation-1 pa-2">
                            <div :class="{'error-rules': organizationName}">
                                <div class="detail font-weight-bold pa-0 ma-0">Name</div>
                                <v-text-field v-model="organization.name" ref="organizationName" class="im-select ma-0" required solo flat clearable placeholder="Enter your name here" :rules="rules.name" hide-details />
                            </div>
                        </v-card>
                    </v-col>
                    <v-col cols="6" md="6" class="px-2 py-1">
                        <v-card class="elevation-1 pa-2">
                            <div :class="{'error-rules': organizationType}">
                                <div class="detail font-weight-bold pa-0 ma-0">Type</div>
                                <v-select class="im-select pa-0 ma-0" ref="organizationType" flat solo v-model="organization.type" :items="org_types" required placeholder="Select type" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}"
                                    :rules="rules.type" hide-details />
                            </div>
                        </v-card>
                    </v-col>
                    <v-col cols="6" md="6" class="px-2 py-1">
                        <v-card class="elevation-1 pa-2">
                            <div class="detail font-weight-bold pa-0 ma-0">About</div>
                            <v-text-field v-model="organization.about" class="im-select ma-0" solo flat clearable placeholder="Enter your name here" hide-details />
                        </v-card>
                    </v-col>
                    <v-col cols="6" md="6" class="px-2 py-1">
                        <v-card class="elevation-1 pa-2">
                            <div class="detail font-weight-bold pa-0 ma-0">Parent organization</div>
                            <im-search-organizations class="im-select" :organization_id="organization.parent_id" @input="selectParent($event)" placeholder="Select the parent" />
                        </v-card>
                    </v-col>
                    <v-col cols="6" md="6" class="px-2 py-1">
                        <v-card class="elevation-1 pa-2">
                            <div class="detail font-weight-bold pa-0 ma-0">Email</div>
                            <v-text-field v-model="organization.email" class="im-select ma-0" solo flat clearable placeholder="Enter your email here" hide-details />
                        </v-card>
                    </v-col>
                    <v-col cols="6" md="6" class="px-2 py-1">
                        <v-card class="elevation-1 pa-2">
                            <div class="detail font-weight-bold pa-0 ma-0">Phone</div>
                            <v-text-field v-model="organization.phone" class="im-select ma-0" solo flat clearable placeholder="Enter your phone here" hide-details />
                        </v-card>
                    </v-col>
                    <v-col cols="12" class="px-2 py-1">
                        <v-card class="elevation-1 pa-2">
                            <div class="detail font-weight-bold pa-0 ma-0">Address</div>
                            <v-row no-gutters align="center" class="pt-2 im-search">
                                <v-col cols="12" md="6">
                                    <v-layout row no-gutters align="center">
                                        <v-col cols="12" class="px-2">
                                            <v-text-field v-model="organization.address.city" class="ma-0" label="City" />
                                        </v-col>
                                        <v-col cols="9" class="px-2">
                                            <v-text-field v-model="organization.address.region" class="ma-0" label="Region" />
                                        </v-col>
                                        <v-col cols="3" class="px-2">
                                            <v-select class="ma-0" v-model="organization.address.country" :items="countries" clearable label="Country" :menu-props="{transition:'scale-transition', 'offset-y': ''}" hide-details />
                                        </v-col>
                                    </v-layout>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-layout row no-gutters align="center">
                                        <v-col cols="12" class="px-2">
                                            <v-text-field v-model="organization.address.street" class="ma-0" label="Street" hint="street name" />
                                        </v-col>
                                        <v-col cols="4" class="px-2">
                                            <v-text-field v-model="organization.address.number" class="ma-0" label="Number" />
                                        </v-col>
                                        <v-col cols="4" class="px-2">
                                            <v-text-field v-model="organization.address.building" class="ma-0" label="Building" hint="eg: ap., nr." />
                                        </v-col>
                                        <v-col cols="4" class="px-2">
                                            <v-text-field v-model="organization.address.postal_code" class="ma-0" label="Postal Code" />
                                        </v-col>
                                    </v-layout>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>

                    <v-col cols="12" class="px-2 py-1">
                        <v-card class="elevation-1 pa-2">
                            <div class="detail font-weight-bold pa-0 ma-0">Contact</div>
                            <v-row no-gutters align="center" class="pt-2 im-search">
                                <v-col cols="6" class="px-2">
                                    <v-text-field v-model="organization.contact.name" class="ma-0 pa-0" label="Name" clearable />
                                </v-col>
                                <v-col cols="6" class="px-2">
                                    <v-text-field v-model="organization.contact.position" class="ma-0  pa-0" label="Position" clearable />
                                </v-col>
                                <v-col cols="6" class="px-2">
                                    <v-text-field class="ma-0 pa-0" v-model="organization.contact.email" label="Email" clearable hide-details />
                                </v-col>
                                <v-col cols="6" class="px-2">
                                    <v-text-field class="ma-0 pa-0" v-model="organization.contact.phone" label="Phone" clearable hide-details />
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-col cols="12" class="px-2 py-1">
                        <v-expansion-panels>
                            <v-expansion-panel>
                                <v-expansion-panel-header>
                                    <div class="detail font-weight-bold pa-0 ma-0">Social</div>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row no-gutters align="center" class="im-search">
                                        <v-col cols="12" md="6">
                                            <v-row no-gutters align="center">
                                                <img src="../../../assets/facebook.svg" height="30px" width="30px" class="ma-1">
                                                <v-text-field class=" py-0 px-2 ma-0" placeholder="Facebook" v-model="organization.social.facebook"></v-text-field>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-row no-gutters align="center">
                                                <img src="../../../assets/instagram.svg" height="30px" width="30px" class="ma-1">
                                                <v-text-field class="py-0 px-2 ma-0" placeholder="Instagram" v-model="organization.social.instagram"></v-text-field>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-row no-gutters align="center">
                                                <img src="../../../assets/twitter.svg" height="30px" width="30px" class="ma-1">
                                                <v-text-field class="py-0 px-2 ma-0" placeholder="Twitter" v-model="organization.social.twitter"></v-text-field>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-row no-gutters align="center">
                                                <img src="../../../assets/linkedin.svg" height="30px" width="30px" class="ma-1">
                                                <v-text-field class="py-0 px-2 ma-0" placeholder="Linkedin" v-model="organization.social.linkedin"></v-text-field>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-row no-gutters align="center">
                                                <img src="../../../assets/youtube.svg" height="30px" width="30px" class="ma-1">
                                                <v-text-field class="py-0 px-2 ma-0" placeholder="Youtube" v-model="organization.social.youtube"></v-text-field>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-row no-gutters align="center">
                                                <img src="../../../assets/google_plus.svg" height="30px" width="30px" class="ma-1">
                                                <v-text-field class="py-0 px-2 ma-0" placeholder="Google plus" v-model="organization.social.google_plus"></v-text-field>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-row no-gutters align="center">
                                                <img src="../../../assets/tumblr.svg" height="30px" width="30px" class="ma-1">
                                                <v-text-field class="py-0 px-2 ma-0" placeholder="Tumblr" v-model="organization.social.tumblr"></v-text-field>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-row no-gutters align="center">
                                                <img src="../../../assets/pinterest.svg" height="30px" width="30px" class="ma-1">
                                                <v-text-field class="py-0 px-2 ma-0" placeholder="Pinterest" v-model="organization.social.pinterest"></v-text-field>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>

                    </v-col>
                    <v-col cols="6" md="6" class="px-2 py-1">
                        <v-card class="elevation-1 pa-2">
                            <div class="detail font-weight-bold pa-0 ma-0">Website</div>
                            <v-text-field v-model="organization.website" class="im-select ma-0" solo flat clearable placeholder="Enter your website here" hide-details />
                        </v-card>
                    </v-col>
                    <v-col cols="6" md="6" class="px-2 py-1">
                        <v-card class="elevation-1 pa-2">
                            <div class="detail font-weight-bold pa-0 ma-0">Timezone</div>
                            <v-select class="im-select pa-0 ma-0" flat solo v-model="organization.timezone" :items="timezone" placeholder="Place timezone location" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}" hide-details />
                        </v-card>
                    </v-col>
                </v-layout>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <input id="upload" type="file" style="display: none" ref="fileInput" accept="image/*" @change="onFilePicked">
            <v-spacer></v-spacer>
            <v-btn color="primary" :loading="loading_save" @click="save">Save</v-btn>
            <v-btn text @click="emitExit()">Cancel</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
import {
    mapActions
} from 'vuex';
import defaults from "../../utils/PropDefaults.js"
import IMOrganizationSearch from '../../utils/OrganizationSearch.vue';

export default {
    components: {
        "im-search-organizations": IMOrganizationSearch,
    },
    props: {
        dialog: {
            type: Boolean,
            default: true
        },
        item_id: [Number, String],
    },
    data() {
        return {
            organizationName: false,
            organizationType: false,
            bill: false,
            loading_delete: false,
            loading_save: false,
            // item model
            child: {},
            organization: defaults.organization_item,
            countries: [
                "RO",
                "BG",
                "MD"
            ],
            timezone: [
                "Europe/Amsterdam",
                "Europe/Athens",
                "Europe/Belgrade",
                "Europe/Berlin",
                "Europe/Bratislava",
                "Europe/Bucharest",
                "Europe/Budapest",
                "Europe/Chisinau",
                "Europe/Helsinki",
            ],

            // modals
            child_dialog: false,
            edit_dialog: false,
            delete_dialog: false,
            dialog_mobile_sort: false,
            organization_dialog: false,

            // organization_types
            org_types: [
                {
                    text: 'Supplier',
                    value: 'supplier'
                }, {
                    text: 'Agency',
                    value: 'agency'
                }, {
                    text: 'Operator',
                    value: 'operator'
                }, {
                    text: 'Master',
                    value: 'master'
                }
            ],

            //table
            loading: false,

            //validation rules
            valid: false,
            rules: {
                name: [v => !!v || 'Name is required.'],
                type: [v => !!v || 'Type is required.'],
                address: [v => !!v || 'Address is required.']
            }
        }
    },

    watch: {
        dialog: {
            handler() {
                if(this.dialog) {
                    this.getItem();
                }
            }
        }
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        // oraganizations functions
        getItem() {
            if(!this.item_id) {
                return
            }
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/profiles/organizations/';

            this.$axios.get(endpoint + this.item_id)
                .then(response => {
                    this.organization = response.data;
                })
                .catch(error => {
                    this.error('Oops, something went wrong!');
                    console.log(error);
                })
        },

        save() {
            this.organizationName = this.$refs.organizationName.hasError;
            this.organizationType = this.$refs.organizationType.hasError;
            // validate
            if(!this.$refs.organization_form.validate()) {
                return
            }

            // we are loading
            this.loading_save = true;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/profiles/organizations';

            // call update or save endpoints
            if(this.organization.id) {
                this.$axios.put(endpoint + '/' + this.organization.id, this.organization) // eslint-disable-next-line
                    .then(response => {
                        this.$emit('refresh');
                        this.success('Organization updated.');
                    })
                    .catch(error => {
                        this.error('Oops, something went wrong!');
                        console.error(error);
                    })
                    .finally(() => {
                        this.loading_save = false;
                    });
            } else {
                this.$axios.post(endpoint, this.organization) // eslint-disable-next-line
                    .then(response => {
                        this.$emit('refresh');
                        this.success('Organization created.');
                    })
                    .catch(error => {
                        this.error('Oops, something went wrong!');
                        console.log(error);
                    })
                    .finally(() => {
                        this.loading_save = false;
                    });
            }
        },

        onFilePick() {
            this.$refs.fileInput.click();
        },

        onFilePicked(event) {
            let files = event.target.files;
            let fileReader = new FileReader();
            fileReader.addEventListener('load', () => {
                this.organization.avatar = fileReader.result
            });
            fileReader.readAsDataURL(files[0]);
        },


        formatDate(value) {
            if(!value) return value;
            return this.$moment(String(value))
                .format('DD MMM YY');
        },


        selectParent(parent) {
            if(parent) {
                this.organization.parent_id = parent.id;
            } else {
                this.organization.parent_id = null;
            }
        },

        emitExit() {
            this.$emit('exit')
        }


    }
}
</script>
<style>
.error-rules .v-text-field ::placeholder {
    color: red;
}
</style>
